import { Col, Row } from 'antd'
import assets from '../../../../assets/images'

const Home = () => (
  <>
    <Row justify="center" style={{ alignItems: 'center', flexFlow: 'row' }} type="flex">
      <Col className="user-guide-text" style={{ textAlign: 'left' }}>
        <h2>User Guide</h2>
        <p>Need help? You can check out the user guide here.</p>
        <a href="https://sites.google.com/terracycle.com/loop-it-team-space/user-manuals/mobile-admin-user-manuals" rel="noopener noreferrer" target="_blank">
            Mobile Admin User Manuals
        </a>
      </Col>
      <Col style={{ backgroundImage: `url(${assets.userGuide})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain', height: '400px', marginTop: '20px', width: '450px' }}>
      </Col>
    </Row>
  </>
)

export default Home
